import React from 'react';

const EmptyTableIcon = () => {
  return (
    <svg
      width='118'
      height='104'
      viewBox='0 0 118 104'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M58.9722 81.5996C59.5134 81.5996 59.9522 81.1609 59.9522 80.6196C59.9522 80.0784 59.5134 79.6396 58.9722 79.6396C58.431 79.6396 57.9922 80.0784 57.9922 80.6196C57.9922 81.1609 58.431 81.5996 58.9722 81.5996Z'
        fill='#CFCFCF'
      />
      <path
        d='M30.5 7.82031V12.1203'
        stroke='#BABABA'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M28.3438 9.96973H32.6538'
        stroke='#BABABA'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M79.4512 34.9403C71.0812 34.9403 62.5612 34.6003 54.5912 32.3803C46.7712 30.2103 39.5912 26.0003 33.1912 21.1303C29.0012 17.9603 25.1912 15.4303 19.7512 15.8103C14.4293 16.0983 9.34 18.0857 5.23121 21.4803C-1.68879 27.5403 -0.648793 38.7703 2.12121 46.6303C6.28121 58.5003 18.9412 66.7703 29.7012 72.1203C42.1312 78.3303 55.7912 81.9403 69.4812 84.0103C81.4812 85.8403 96.9012 87.1603 107.301 79.3303C116.851 72.1203 119.471 55.6803 117.131 44.5803C116.563 41.3012 114.817 38.3424 112.221 36.2603C105.511 31.3503 95.5012 34.6303 87.9612 34.7903C85.1612 34.8503 82.3112 34.9203 79.4512 34.9403Z'
        fill='#F2F2F2'
      />
      <path
        d='M65.9097 1.96C66.4509 1.96 66.8897 1.52124 66.8897 0.98C66.8897 0.43876 66.4509 0 65.9097 0C65.3685 0 64.9297 0.43876 64.9297 0.98C64.9297 1.52124 65.3685 1.96 65.9097 1.96Z'
        fill='#CFCFCF'
      />
      <path
        d='M14.9922 78.2695V82.5695'
        stroke='#BABABA'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M12.8438 80.4199H17.1437'
        stroke='#BABABA'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M59.3741 103.47C79.6484 103.47 96.0841 102.444 96.0841 101.18C96.0841 99.9149 79.6484 98.8896 59.3741 98.8896C39.0997 98.8896 22.6641 99.9149 22.6641 101.18C22.6641 102.444 39.0997 103.47 59.3741 103.47Z'
        fill='#F2F2F2'
      />
      <path
        d='M88.8848 76.6501H25.4748C25.0505 76.6498 24.6312 76.5574 24.2461 76.3791C23.861 76.2009 23.5192 75.9411 23.2444 75.6177C22.9696 75.2944 22.7682 74.9152 22.6544 74.5064C22.5405 74.0976 22.5167 73.669 22.5848 73.2501L30.6948 24.0701C30.8044 23.3857 31.1547 22.7628 31.6827 22.3136C32.2107 21.8645 32.8816 21.6186 33.5748 21.6201H96.9848C97.4089 21.6202 97.8278 21.7126 98.2125 21.8909C98.5973 22.0692 98.9385 22.3292 99.2126 22.6528C99.4867 22.9764 99.687 23.3558 99.7997 23.7646C99.9123 24.1734 99.9345 24.6018 99.8648 25.0201L91.7948 74.2001C91.6825 74.8888 91.3273 75.5146 90.7935 75.964C90.2597 76.4134 89.5826 76.6568 88.8848 76.6501Z'
        fill='#D2D2D2'
      />
      <path
        d='M89.6633 20.3339L52.0245 3.52876C50.915 3.0334 49.6141 3.53123 49.1187 4.6407L37.1896 31.3586C36.6942 32.468 37.1921 33.769 38.3015 34.2643L75.9403 51.0695C77.0498 51.5648 78.3507 51.067 78.8461 49.9575L90.7752 23.2397C91.2705 22.1302 90.7727 20.8292 89.6633 20.3339Z'
        fill='white'
        stroke='#BABABA'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M57.5391 25.5096C58.5298 24.1194 59.9707 23.1145 61.6175 22.6652C63.2644 22.2159 65.016 22.3498 66.5754 23.0442C68.1349 23.7386 69.4063 24.9508 70.1742 26.4754C70.9422 28 71.1594 29.7431 70.7891 31.4096'
        stroke='#BABABA'
        strokeWidth='0.68'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M75.5378 24.0004C76.1067 24.0004 76.5678 23.5393 76.5678 22.9704C76.5678 22.4016 76.1067 21.9404 75.5378 21.9404C74.969 21.9404 74.5078 22.4016 74.5078 22.9704C74.5078 23.5393 74.969 24.0004 75.5378 24.0004Z'
        fill='#BABABA'
      />
      <path
        d='M60.6237 17.3403C61.1926 17.3403 61.6537 16.8791 61.6537 16.3103C61.6537 15.7414 61.1926 15.2803 60.6237 15.2803C60.0549 15.2803 59.5938 15.7414 59.5938 16.3103C59.5938 16.8791 60.0549 17.3403 60.6237 17.3403Z'
        fill='#BABABA'
      />
      <path
        d='M88.6018 76.6295H24.8818C24.1064 76.6269 23.3637 76.317 22.8164 75.7678C22.2691 75.2186 21.9618 74.4749 21.9618 73.6995V28.7695C21.9525 28.3797 22.021 27.992 22.1635 27.6291C22.3059 27.2661 22.5194 26.9353 22.7913 26.6559C23.0633 26.3765 23.3882 26.1542 23.7472 26.002C24.1062 25.8498 24.4919 25.7708 24.8818 25.7695H48.0918C48.6303 25.7715 49.1579 25.9219 49.6166 26.2042C50.0753 26.4864 50.4473 26.8896 50.6918 27.3695L54.0018 33.8495C54.2453 34.3301 54.6171 34.734 55.076 35.0164C55.5349 35.2988 56.063 35.4487 56.6018 35.4495H88.6018C89.3762 35.4495 90.1189 35.7572 90.6665 36.3048C91.2141 36.8524 91.5218 37.5951 91.5218 38.3695V73.6995C91.5218 74.4749 91.2145 75.2186 90.6671 75.7678C90.1198 76.317 89.3771 76.6269 88.6018 76.6295Z'
        fill='white'
        stroke='#BABABA'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M78.7919 36.9805C75.1107 36.9785 71.5117 38.0683 68.45 40.112C65.3883 42.1557 63.0014 45.0614 61.5914 48.4618C60.1813 51.8622 59.8113 55.6043 60.5282 59.215C61.2452 62.8256 63.0168 66.1425 65.6191 68.7462C68.2213 71.3498 71.5373 73.1233 75.1476 73.8422C78.7578 74.561 82.5002 74.1931 85.9013 72.7848C89.3024 71.3766 92.2095 68.9913 94.2548 65.9307C96.3002 62.8701 97.3919 59.2716 97.3919 55.5905C97.3919 50.6565 95.4326 45.9245 91.9447 42.4347C88.4568 38.945 83.7258 36.9831 78.7919 36.9805Z'
        fill='white'
        stroke='#BABABA'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M92.0312 69.0898L96.9912 74.0498'
        stroke='#BABABA'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M96.4323 71.6403L94.8913 73.2522C94.2006 73.9748 94.2264 75.1205 94.949 75.8113L108.322 88.5949C109.044 89.2857 110.19 89.2599 110.881 88.5373L112.422 86.9254C113.112 86.2028 113.087 85.057 112.364 84.3663L98.9914 71.5826C98.2688 70.8919 97.1231 70.9177 96.4323 71.6403Z'
        fill='#D2D2D2'
      />
      <path
        d='M106.328 0.980469V5.29047'
        stroke='#BABABA'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M104.172 3.13965H108.482'
        stroke='#BABABA'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};

export default EmptyTableIcon;
